import FiberLitBuildingsLayer from './FiberLitBuildingsLayer';
import SiteDataLayers from './SiteDataLayers';

/**
 * The project-scoped overlays every project map offers, as one mount.
 *
 * Custom Data is deliberately not here: it registers its own picker group on mount, so offering
 * it on the CivilDraw maps is a product change rather than a missing draw — see ENG-4364.
 *
 * `interactive={false}` drops the Site Data click affordances (field-note viewer, pothole edit
 * dialog) for read-only surfaces such as the CivilDraw print view. Each child still decides for
 * itself whether to draw.
 */
export default function ProjectDataLayers({
  projectId,
  interactive = true,
}: {
  projectId: string;
  interactive?: boolean;
}) {
  if (!projectId) return null;

  return (
    <>
      <FiberLitBuildingsLayer projectId={projectId} />
      <SiteDataLayers projectId={projectId} interactive={interactive} />
    </>
  );
}
